module.exports = __webpack_public_path__ + "static/media/RH-Switch.f79dcf3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RH-Switch.png
// module id = 713
// module chunks = 0